import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/upload.module.css";
import { LanguageContext } from "../../../Context/changeLanguageProvider";

function Upload({ handleFile, clearField, disabled }) {
  const [fieldValue, setFieldValue] = useState("");
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  useEffect(() => {
    if (clearField) {
      setFieldValue("");
    }
  }, [clearField]);

  return (
    <div disabled={disabled} className={styles.main}>
      <input
        style={{ opacity: "0", width: "100%", height: "100%", zIndex: 1 }}
        type={"file"}
        value={fieldValue}
        onChange={handleFile}
        multiple
      ></input>
      <div className={styles.inside_text}>
        {dublicatedcontent?.dublicatedText220}
      </div>
    </div>
  );
}

export default Upload;
